import * as React from 'react';
import { AuthErrorPage } from 'src/react/errorPage/components/AuthErrorPage';

export default function (): JSX.Element {
    return <AuthErrorPage/>;
}
